<template>
	<l-modal class="m-no-internet">
		<template v-slot:icon>
			<c-icon
				class="icon"
				src="@icons/noInternet"
			/>
		</template>

		<template v-slot:header>
			{{ $t('NO_INTERNET.INFO.TITLE') }}
		</template>

		<div class="m-no-internet__content">
			<p class="m-no-internet__desc">
				{{ $t('NO_INTERNET.INFO.DESC') }}
			</p>
			<c-contact-support-info />
			<p class="m-no-internet__contact">
				{{ $t('NO_INTERNET.CONTACT_US') }}
			</p>
		</div>

		<template v-slot:buttons>
			<c-button
				data-testid="accept"
				confirm
				@click="$emit('close')"
			>
				{{ $t('ACTIONS.ACCEPT') }}
			</c-button>
		</template>
	</l-modal>
</template>

<script>
import LModal from '@layouts/l-modal';
import CButton from '@fam/components/c-button';
import CIcon from '@components/c-icon';
import CContactSupportInfo from '@fam/components/c-contact-support-info';

export default {
	name: 'm-no-internet',

	components: {
		LModal,
		CButton,
		CIcon,
		CContactSupportInfo,
	},
};
</script>

<style lang="scss" scoped>
.m-no-internet__content {
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 120px;
	margin: 0 auto;
	gap: var(--spacing-l);
}
</style>
